import { useCanAccessCampaignsInsights, useCanCreateCampaigns } from '../campaignRights';

export const useIsCampaignsEntryPointVisible = (): boolean => {
  const canAccessCampaignInsights = useCanAccessCampaignsInsights();
  const canCreateCampaigns = useCanCreateCampaigns();
  const hasCampaignAnalyticsAccess = canAccessCampaignInsights || canCreateCampaigns;

  return hasCampaignAnalyticsAccess;
};
